var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.storeCode,staticClass:"full-page"},[(this.$route.name == 'store')?[_vm._v(" Loading Store... ")]:[_c('router-view')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }